const FOOTER_NAV = [
  { href: '#hot', label: '吃瓜热搜榜' },
  { href: '#feeds', label: '栏目吃瓜' },
  { href: '#love-line', label: '感情线专题' },
  { href: '#poll', label: '吃瓜投票' },
  { href: '#about', label: '关于与口碑' },
  { href: '#faq', label: '常见问题' },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 pt-12 pb-8 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-quill-pen-fill text-lg" />
              </span>
              <span className="leading-tight">
                <span className="block text-[15px] font-bold text-foreground-950">八卦吃瓜</span>
                <span className="block text-[10px] font-semibold tracking-[0.28em] text-primary-600">
                  CELEB·LOVE
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              专注明星恋情与绯闻的娱乐资讯站，把零散物料整理成有依据的恋情与感情线时间线。吃瓜要上头，真相与边界同样不让步。
            </p>
            <a
              href="#subscribe"
              className="mt-5 inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-notification-3-line mr-2 text-base" />
              订阅吃瓜速报
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <i className="ri-compass-3-line text-accent-600" />
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_NAV.map((n) => (
                <li key={n.href + n.label}>
                  <a
                    href={n.href}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-arrow-right-s-line text-accent-600" />
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <i className="ri-customer-service-2-line text-accent-600" />
              与我们聊聊
            </h4>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              有料可投、有误要纠，或有合作意向，欢迎随时来信。经核实无误的线索，我们会第一时间跟进并标注来源。
            </p>
            <div className="mt-4 space-y-2 text-sm text-foreground-700">
              <p className="inline-flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" />
                <a href="mailto:hello@example.com" className="transition-colors hover:text-primary-700">
                  hello@example.com
                </a>
              </p>
              <p className="inline-flex items-center gap-2">
                <i className="ri-global-line text-primary-600" />
                八卦吃瓜 · CELEB LOVE NEWS
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 八卦吃瓜. 本站内容基于公开可查物料整理，仅供娱乐参考。
          </p>
          <p className="flex items-center gap-1 text-xs text-foreground-500">
            吃瓜有度，理性追星
            <i className="ri-heart-3-fill text-primary-500" />
          </p>
        </div>
      </div>
    </footer>
  );
}